$(document).ready(function () {
    if ($('#my-previa-pro').length) {

      if ($('#id_customer_context').length) {
        $('#id_customer_context').change(function () {
          $('#set_customer_context').submit();
        });
      }

      $('#stampami').click(function () {
        var currentScroll = $(document).scrollTop();
        window.scrollTo(0,0);
        $(this).hide();
        $(this).after('<div class="destroy" style="float:right;"><img src="modules/ordine/miniloader.gif"> &nbsp;Creazione PDF in corso...</div>');

        html2canvas(document.getElementById('stampa')).then(function(canvas) {

            var img = canvas.toDataURL();
            var a = document.createElement('a');
            // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
            a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
            a.download = 'somefilename.jpg';
            a.click();
        });
        window.scrollTo(0,currentScroll);

      });

    }
  }
);




// WEBPACK FOOTER //
// ./js/my-previa-pro.js